import * as Actions from "../Actions/AlertasActions";

const initialState = {
    data: null,
    error: null,
    preload: false,
};

const AlertasReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ALERTAS:
            {
                return {
                    ...state,
                    data: action.payload,
                    error: null,
                };
            }
        case Actions.ALERTAS_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                    preload: false,
                };
            }
        case Actions.ALERTAS_CHANGE_PRELOAD:
            {
                return {
                    ...state,
                    preload: !state.preload,
                };
            }
        default:
            return state;
    }
};

export default AlertasReducer;
